import {
  StandardCheckBox,
  RoundCheckBox,
  RadioButtons,
  SingleSelector,
  MultiSelector,
  SpecialCaseSelector,
  DropDowns,
  DropDownsSimplified,
  StandardInputText,
  PasswordTextInput,
  PhoneNumberInput,
  CardNumberInput,
  SearchFieldInput,
  SearchFieldWithPrefix,
  SearchWithWordFinder,
  SearchWithClearField
} from './inputsLayouts';

import {
  standardCheckBoxesCode,
  roundCheckBoxesCode,
  radioButtonsCode,
  singleSelectorCode,
  multiSelectorCode,
  specialCaseSelectorCode,
  dropdownsCode,
  dropdownsSimplifiedCode,
  standardInputTextCode,
  passwordInputCode,
  phoneNumberCode,
  cardNumberCode,
  searchFieldCode,
  searchFieldPrefixCode,
  searchWithWordFinderCode,
  searchWithClearFieldCode
} from './inputsCode';

const headersSet = [
  {
    type: 'check boxes',
    previews: [
      {
        component: StandardCheckBox,
        codeTemplate: standardCheckBoxesCode,
        optionsGroup: [
          {
            label: 'Check Boxes',
            options: [
              {label: 'Table', type: 'radio', options: {label: null}},
              {label: 'Settings and Configurations', type: 'radio', options: {label: 'Side-label'}}
            ]
          },
          {
            label: 'Colour',
            options: [
              {label: 'Light', type: 'radio', options: {darkBg: null, bgColor: null}},
              {label: 'Dark', type: 'radio', options: {darkBg: true, bgColor: 'black'}}
            ]
          },
        ],
      },
      {
        component: RoundCheckBox,
        codeTemplate: roundCheckBoxesCode,
        optionsGroup: [
          {
            label: 'Round Check Boxes',
            options: [
              {label: 'Header', type: 'radio', options: {table: null}},
              {label: 'Table', type: 'radio', options: {table: true}}
            ]
          }
        ],
      }
    ]
  },
  {
    type: 'radio buttons',
    previews: [
      {
        component: RadioButtons,
        codeTemplate: radioButtonsCode,
        optionsGroup: [
          {
            label: 'Radio Buttons',
            options: [
              {label: 'Light', type: 'radio', options: {darkBg: null, bgColor: null}},
              {label: 'Dark', type: 'radio', options: {darkBg: true, bgColor: 'black'}}
            ]
          },
        ],
      }
    ]
  },
  {
    type: 'selectors',
    previews: [
      {
        component: SingleSelector,
        codeTemplate: singleSelectorCode,
        optionsGroup: [
          {
            label: 'Single Selector',
            options: [
              {label: 'Large', type: 'radio', options: {large: true}},
              {label: 'Medium', type: 'radio', options: {large: null}}
            ]
          },
          {
            label: 'Text:',
            options: [
              {label: '1 Line', type: 'radio', options: {text: 'Input Text', doubleLine: false}},
              {label: '2 Lines', type: 'radio', options: {text: 'Double Line Text', doubleLine: true}}
            ]
          },
          {
            label: 'Background:',
            options: [
              {label: 'Light', type: 'radio', options: {withBg: null, bgColor: null}},
              {label: 'Dark', type: 'radio', options: {withBg: true, bgColor: 'black'}}
            ]
          },
          {
            label: 'Extra:',
            options: [
              {label: 'Icon', type: 'checkbox', options: {icon: 'apps'}},
              {label: 'Complementary Text', type: 'checkbox', options: {label: 'label'}}
            ]
          },
        ],
      },
      {
        component: MultiSelector,
        codeTemplate: multiSelectorCode,
        optionsGroup: [
          {
            label: 'Multi Selector',
            options: [
              {label: 'Large', type: 'radio', options: {large: true}},
              {label: 'Medium', type: 'radio', options: {large: null}}
            ]
          },
          {
            label: 'Text:',
            options: [
              {label: '1 Line', type: 'radio', options: {text: 'Input Text', doubleLine: false}},
              {label: '2 Lines', type: 'radio', options: {text: 'Double Line Text', doubleLine: true}}
            ]
          },
          {
            label: 'Background:',
            options: [
              {label: 'Light', type: 'radio', options: {withBg: null, bgColor: null}},
              {label: 'Dark', type: 'radio', options: {withBg: true, bgColor: 'black'}}
            ]
          },
          {
            label: 'Extra:',
            options: [
              {label: 'Icon', type: 'checkbox', options: {icon: 'apps'}},
              {label: 'Complementary Text', type: 'checkbox', options: {label: 'label'}}
            ]
          },
        ],
      },
      {
        component: SpecialCaseSelector,
        codeTemplate: specialCaseSelectorCode,
        optionsGroup: [
          {
            label: 'Special Case',
            options: [
              {label: 'Large', type: 'radio', options: {large: true}},
              {label: 'Medium', type: 'radio', options: {large: null}}
            ]
          },
          {
            label: 'Version:',
            options: [
              {label: 'Avatar', type: 'radio', options: {bgImage: 'Visa', text: null}},
              {label: 'Avatar and Text', type: 'radio', options: {bgImage: 'Visa', text: 'Special Case'}},
            ]
          }
        ],
      }
    ]
  },
  {
    type: 'dropdowns',
    previews: [
      {
        component: DropDowns,
        codeTemplate: dropdownsCode,
        optionsGroup: [
          {
            label: 'Dropdowns',
            options: [
              {label: 'Default', type: 'radio', options: {label: 'label', simplified: false}},
              {label: 'Without Label', type: 'radio', options: {label: null, simplified: false}}
            ]
          },
          {
            label: 'Colour',
            options: [
              {label: 'Light', type: 'radio', options: {darkBg: false, red: false, bgColor: null}},
              {label: 'Dark', type: 'radio', options: {darkBg: true, red: false, bgColor: 'black'}}
            ]
          },
          {
            label: 'Size',
            options: [
              {label: 'Light', type: 'dropdown', selectList: [
                  {label: '36px', value: '36px', options: {size: 'xl'}},
                  {label: '30px', value: '30px', options: {size: 'l'}},
                  {label: '24px', value: '24px', options: {size: 'm'}},
                  {label: '20px', value: '20px', options: {size: 's'}},
                  {label: '16px', value: '16px', options: {size: null}},
                ]
              },
            ]
          },
        ],
      },
      {
        component: DropDownsSimplified,
        codeTemplate: dropdownsSimplifiedCode,
        optionsGroup: [
          {
            label: 'Simplified',
            options: [
              {label: 'Default', type: 'radio', options: {}},
            ]
          },
          {
            label: 'Colour',
            options: [
              {label: 'Light', type: 'radio', options: {darkBg: false, red: false, bgColor: null}},
              {label: 'Dark', type: 'radio', options: {darkBg: true, red: false, bgColor: 'black'}},
              {label: 'Red', type: 'radio', options: {darkBg: false, red: true, bgColor: null}}
            ]
          },
          {
            label: 'Size',
            options: [
              {label: 'sizes', type: 'dropdown', selectList: [
                  {label: '36px', value: '36px', options: {size: 'xl'}},
                  {label: '30px', value: '30px', options: {size: 'l'}},
                  {label: '24px', value: '24px', options: {size: 'm'}},
                  {label: '20px', value: '20px', options: {size: 's'}},
                  {label: '16px', value: '16px', options: {size: null}},
                ]
              },
            ]
          },
        ],
      }
    ]
  },
  {
    type: 'text fields',
    previews: [
      {
        component: StandardInputText,
        codeTemplate: standardInputTextCode,
        optionsGroup: [
          {
            label: 'Standard',
            options: [
              {label: 'sizes', type: 'dropdown', selectList: [
                  {label: '60px', value: '60px', options: {size: 'extra-large'}},
                  {label: '48px', value: '48px', options: {size: 'large'}},
                  {label: '36px', value: '36px', options: {size: 'medium-large'}},
                  {label: '30px', value: '30px', options: {size: 'medium'}},
                  {label: '24px', value: '24px', options: {size: 'normal'}},
                  {label: '20px', value: '20px', options: {size: 'small'}},
                  {label: '16px', value: '16px', options: {size: 'extra-small'}},
                ]
              },
            ]
          },
          {
            label: 'Supplements',
            options: [
              {label: 'Dropdown', type: 'checkbox', options: {
                  dropdownLabel: {opts: ['option1', 'option2', 'option3'] },
                  customClasses: 'withDropDown',
                },
                uncheckedOptions: {
                  dropdownLabel: null,
                  customClasses: 'withDropDown',
                }
              },
              {label: 'Icon', type: 'checkbox', options: {
                  icon: {icon: 'link-arrow-right-17', type: 'other'},
                  customClasses: 'withIcon',
                },
                uncheckedOptions: {
                  icon: null,
                  customClasses: 'withIcon',
                }
              },
              {label: 'Label', type: 'checkbox', options: {
                  label: 'label',
                },
                uncheckedOptions: {
                  label: null,
                }
              },
              {label: 'Note', type: 'checkbox', options: {
                  note: 'Helper note',
                },
                uncheckedOptions: {
                  note: null,
                }
              },
              {label: 'Prefix', type: 'checkbox', options: {
                  prefixText: 'Rs.',
                },
                uncheckedOptions: {
                  prefixText: null,
                }
              },
              {label: 'Suffix', type: 'checkbox', options: {
                  suffixText: '%'
                },
                uncheckedOptions: {
                  suffixText: null,
                }
              },
            ]
          },
          {
            label: 'Background:',
            options: [
              {label: 'Light', type: 'radio', options: {darkBg: false, bgColor: null}},
              {label: 'Dark', type: 'radio', options: {darkBg: true, bgColor: 'black'}},
            ]
          }
        ],
      },
      {
        component: PasswordTextInput,
        codeTemplate: passwordInputCode,
        optionsGroup: [
          {
            label: 'Password',
            options: [
              {label: 'Default', type: 'radio', options: {}},
            ]
          }
        ]
      },
      {
        component: PhoneNumberInput,
        codeTemplate: phoneNumberCode,
        optionsGroup: [
          {
            label: 'Phone Number',
            options: [
              {label: 'Standard', type: 'radio', options: {locked: false}},
              {label: 'Locked CC', type: 'radio', options: {locked: true}}
            ]
          }
        ]
      },
      {
        component: CardNumberInput,
        codeTemplate: cardNumberCode,
        optionsGroup: [
          {
            label: 'Credit Card',
            options: [
              {label: 'Standard', type: 'radio', options: {ccInput: true, expireDate: false, cvv: false, label: 'Credit Card'}},
              {label: 'Expire Date', type: 'radio', options: {ccInput: false, expireDate: true, cvv: false, label: 'Credit Card Date'}},
              {label: 'CVV', type: 'radio', options: {ccInput: false, expireDate: false, cvv: true, label: 'Credit Card CCV'}},
            ]
          }
        ]
      }
    ]
  },
  {
    type: 'search fields',
    previews: [
      {
        component: SearchFieldInput,
        codeTemplate: searchFieldCode,
        optionsGroup: [
          {
            label: 'Search Fields',
            options: [
              {label: 'Standard', type: 'radio', options: {label: 'label'}},
              {label: 'Without Label', type: 'radio', options: {label: null}}
            ]
          },
          {
            label: 'Background:',
            options: [
              {label: 'Light', type: 'radio', options: {darkBg: null, bgColor: null}},
              {label: 'Dark', type: 'radio', options: {darkBg: true, bgColor: 'black'}}
            ]
          },
          {
            label: 'Size:',
            options: [
              {label: 'sizes', type: 'dropdown', selectList: [
                  {label: '60px', value: '60px', options: {size: 'extra-large'}},
                  {label: '48px', value: '48px', options: {size: 'large'}},
                  {label: '36px', value: '36px', options: {size: 'medium-large'}},
                  {label: '30px', value: '30px', options: {size: 'medium'}},
                  {label: '24px', value: '24px', options: {size: 'normal'}},
                  {label: '20px', value: '20px', options: {size: 'small'}},
                  {label: '16px', value: '16px', options: {size: 'extra-small'}},
                ]
              },
            ]
          },
        ],
      },
      {
        component: SearchFieldWithPrefix,
        codeTemplate: searchFieldPrefixCode,
        optionsGroup: [
          {
            label: 'With prefix:',
            options: [
              {label: 'Light', type: 'radio', options: {prefixText: 'Lorem', darkBg: null, bgColor: null}},
              {label: 'Dark', type: 'radio', options: {prefixText: 'Lorem', darkBg: true, bgColor: 'black'}}
            ]
          },
          {
            label: 'Size:',
            options: [
              {label: 'sizes', type: 'dropdown', selectList: [
                  {label: '24px', value: '24px', options: {size: 'normal'}},
                  {label: '16px', value: '16px', options: {size: 'extra-small'}},
                  {label: '20px', value: '20px', options: {size: 'small'}},
                  {label: '30px', value: '30px', options: {size: 'medium'}},
                  {label: '36px', value: '36px', options: {size: 'medium-large'}},
                  {label: '48px', value: '48px', options: {size: 'large'}},
                  {label: '60px', value: '60px', options: {size: 'extra-large'}},
                ]
              },
            ]
          },
        ],
      },
      {
        component: SearchWithWordFinder,
        codeTemplate: searchWithWordFinderCode,
        optionsGroup: [
          {
            label: 'Word Finder',
            options: [
              {label: 'Default', type: 'radio', options: {}},
            ]
          }
        ],
      },
      {
        component: SearchWithClearField,
        codeTemplate: searchWithClearFieldCode,
        optionsGroup: [
          {
            label: 'Overlay Search Field',
            options: [
              {label: 'Light', type: 'radio', options: {darkBg: null, bgColor: null}},
              {label: 'Dark', type: 'radio', options: {darkBg: true, bgColor: 'black'}}
            ]
          },
          {
            label: 'Size:',
            options: [
              {label: 'sizes', type: 'dropdown', selectList: [
                  {label: '36px', value: '36px', options: {size: 'medium-large'}},
                  {label: '48px', value: '48px', options: {size: 'large'}},
                  {label: '60px', value: '60px', options: {size: 'extra-large'}},
                ]
              },
            ]
          }
        ],
      }
    ]
  },
];

export default headersSet;



// WEBPACK FOOTER //
// ./src/containers/elements/Inputs/constants/inputsSet.js